import React from 'react'

export default function Loading() {
    return (
        <div className="lds-roller">
            {Array.from({length:8}).map((_,index)=><div key={index}/>)}
        </div>
    )
}